import { render, staticRenderFns } from "./ResourceSummary.vue?vue&type=template&id=328bdabe&scoped=true"
import script from "./ResourceSummary.vue?vue&type=script&lang=js"
export * from "./ResourceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328bdabe",
  null
  
)

export default component.exports